<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clip-rule="evenodd"
      d="M.75 12c0 6.213 5.037 11.25 11.25 11.25S23.25 18.213 23.25 12 18.213.75 12 .75.75 5.787.75 12Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      clip-rule="evenodd"
      d="M3.75 12a8.25 8.25 0 1 0 16.5 0 8.25 8.25 0 0 0-16.5 0Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20.1 10.444A24.951 24.951 0 0 0 12 9c-2.76.03-5.498.517-8.1 1.444M3.88 13.475c3.618-.659 6.5 1.5 5.909 6.475M20.12 13.475c-3.618-.659-6.5 1.5-5.909 6.475M12 12c.207 0 .375.168.375.375M11.625 12.375c0-.207.168-.375.375-.375M12 12.75a.375.375 0 0 1-.375-.375M12.375 12.375a.375.375 0 0 1-.375.375"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
